/* @flow */

import { API } from '../utils/constants';
import getTokenApi from '../login/get-token-api';

const criarUrlImprimirPorPedidosId = (pedidoId: number) => (
    `${API}/pedidos/${pedidoId}/impressoes?imprimir=1&token=${getTokenApi()}`
);

export default criarUrlImprimirPorPedidosId;
